// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_p0-5";
export var filledCircle = "_p0-4";
export var historyEntry = "_p0-3";
export var messageSideLeft = "_p0-1";
export var messageSideRight = "_p0-2";
export var orderTrackingCarouselWrapper = "_p0-6";
export var orderTrackingInfoContainer = "_p0-0";